import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { axiosInstance } from "../../utils/axiosInstance";

export const fetchApplicationById = createAsyncThunk(
  "applicationDetails/fetchData",
  async (id: number) => {
    const response = await axiosInstance.get(`/appsetup/application/${id}`);
    return response.data.data;
  },
);
export interface ApplicationDetailsById {
  id: number;
  status: string;
  app_cmdb_id: string;
  app_cmdb_name: string;
  ad_app_guid: string;
  description: string;
  primary_contact: string;
  business_owner: string;
  feature_names: string[];
  protected_by_name: string;
  appadmin: string;
  approver: string;
  application_domain_name: any;
  value_stream_name?: any;
  primary_contact_name: string;
  business_owner_name: string;
  publish_approver: string;
  platform_app?: boolean;
  comment?: string;
}

export interface initialState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  editMode: boolean;
  data: ApplicationDetailsById | null;
  appId: number;
  selectedTab: number;
}

export const initialState: initialState = {
  status: "idle",
  editMode: false,
  data: null,
  error: null,
  appId: 0,
  selectedTab: 0,
};

const applicationDetailsSlice = createSlice({
  name: "applicationDetails",
  initialState: initialState,
  reducers: {
    setApplicationEditMode: (state, action) => {
      state.editMode = action.payload;
    },
    setAppId: (state, action) => {
      state.appId = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.editMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchApplicationById.fulfilled,
        (state, action: PayloadAction<ApplicationDetailsById | null>) => {
          state.status = "succeeded";
          state.data = action.payload;
        },
      )
      .addCase(fetchApplicationById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});
export const selectEditMode = (state: RootState) =>
  state.applicationDetails.editMode;
export const { setApplicationEditMode, setAppId, setSelectedTab } =
  applicationDetailsSlice.actions;
export default applicationDetailsSlice.reducer;
